import React from "react";

import {
  PRIVATE_MEDIA_CONFIGURATION,
  PRIVATE_MEDIA_MYM_CLOUD,
  PRIVATE_MEDIA_MYM_CLOUD_COLLECTION
} from "@/shared/constants/routes";
import { RouteConfig } from "@/routes/routes";
import { Route, Routes } from "react-router-dom";

import { ChatLayout } from "../shared/layouts";

const ChatConversationLayout = React.lazy(
  () =>
    import(
      "../creator/presentation/pages/chat-conversation/ChatConversationLayout"
    )
);

const ProposePrivateMediaPage = React.lazy(
  () =>
    import(
      "../creator/presentation/pages/propose-private-media/ProposePrivateMedia"
    )
);

const UserInfoPage = React.lazy(
  () => import("../creator/presentation/pages/user-info/UserInfoPage")
);

const MymCloudPage = React.lazy(
  () => import("../creator/presentation/pages/private-media-mym-cloud/MymCloud")
);

const CollectionPage = React.lazy(
  () =>
    import("../creator/presentation/pages/private-media-collection/Collection")
);

const PrivateMediaRequestPage = React.lazy(
  () =>
    import(
      "../creator/presentation/pages/private-media-request/PrivateMediaRequestPage"
    )
);

const SendPrivateMediaPage = React.lazy(
  () =>
    import(
      "../creator/presentation/pages/private-media-request/send-media/SendPrivateMediaPage"
    )
);

const SendPrivateMediaFormWrapper = React.lazy(
  () =>
    import(
      "../creator/presentation/pages/private-media-request/send-media/SendPrivateMediaFormWrapper"
    )
);

const PrivateMediaFormWrapper = React.lazy(
  () =>
    import(
      "../creator/presentation/pages/propose-private-media/PrivateMediaFormWrapper"
    )
);

const privateMediaRoutesConfig: RouteConfig[] = [
  {
    path: PRIVATE_MEDIA_CONFIGURATION,
    element: <ProposePrivateMediaPage />,
    isPrivate: true
  },
  {
    path: PRIVATE_MEDIA_MYM_CLOUD,
    element: <MymCloudPage />,
    isPrivate: true
  },
  {
    path: PRIVATE_MEDIA_MYM_CLOUD_COLLECTION,
    element: <CollectionPage />,
    isPrivate: true
  }
];

const ChatCreatorRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ChatLayout />}>
        <Route path="" element={<ChatConversationLayout />} />
        <Route path=":userId" element={<ChatConversationLayout />}>
          <Route path="private-media" element={<PrivateMediaFormWrapper />}>
            {privateMediaRoutesConfig.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Route>
          <Route
            path="send-private-media/:messageId"
            element={<SendPrivateMediaFormWrapper />}
          >
            <Route index element={<SendPrivateMediaPage />} />
            <Route path={PRIVATE_MEDIA_MYM_CLOUD} element={<MymCloudPage />} />
            <Route
              path={PRIVATE_MEDIA_MYM_CLOUD_COLLECTION}
              element={<CollectionPage />}
            />
          </Route>
        </Route>
        <Route
          path=":userId/propose-price/:messageId"
          element={<PrivateMediaRequestPage />}
        />
        <Route path=":userId/user-info" element={<UserInfoPage />} />
      </Route>
    </Routes>
  );
};

export const chatRoutes: RouteConfig[] = [
  {
    path: "/chat/*",
    element: <ChatCreatorRoutes />,
    isPrivate: true
  }
];
